<template>
	<section v-if="items.length" class="faq-section background-light">
		<div class="row row-header align-center">
			<h2 class="subtitle">{{ subtitle }}</h2>
			<h2>{{ header }}</h2>
		</div>
		<div class="row faq-row">
			<div class="columns column12">
				<div v-for="(item, index) in items" :key="item.ID" class="faq-item">
					<collapse
						:header="item.question"
						:content="item.answer"
						:is-open="activeIndex === index"
						@click="toggleCollapse(index)"
					/>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
	header: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});

const activeIndex = ref(null);

const toggleCollapse = (index) => {
	activeIndex.value = activeIndex.value === index ? null : index;
};
</script>

<style lang="scss" scoped>
.row {
	max-width: 880px;
}

.faq-section {
	margin: 50px auto;
}

.faq-item {
	text-align: left;
	border-bottom: 1px solid var(--body-color);
	transition: all 0.5s ease-in-out;

	&:first-child {
		border-top: 1px solid var(--body-color);
	}
}

.faq-row {
	margin-bottom: 30px;
}
</style>
